// removed by extract-text-webpack-plugin
module.exports = {"menu":"_1artPAtpZ9hDgNAIg56IIj","profile":"_21diJq2QVsuC7xQO3pS0Wp","menubar":"_3yh0mD4PRddG-t0rvMdhh"};


//////////////////
// WEBPACK FOOTER
// ./src/modules/menu/HappinessMenu.scss
// module id = 664
// module chunks = 0